import { useQuery } from "@tanstack/react-query";
import { getMemberships } from "@/Services/institutions.service";

export function useInstitutionMemberships(institutionId: string | undefined) {
  return useQuery({
    queryKey: ["institution-memberships", institutionId],
    queryFn: () => getMemberships(institutionId!),
    enabled: !!institutionId,
  });
}
